var sanitizeHTML = require('sanitize-html');
var encoding = require('encoding-japanese');

export default {
  camelCase (str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  },
  sanitizeHtml (dirtyValue) {
    if (dirtyValue) {
      return sanitizeHTML(dirtyValue, {
        allowedTags: sanitizeHTML.defaults.allowedTags.concat(['img', 'span', 'button']),
        allowedAttributes: {
          '*': ['href', 'align', 'alt', 'center', 'bgcolor', 'name', 'target', 'src', 'style', 'class']
        }
      });
    }
  },
  bytesToSize (bytes = 0) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0 || !bytes) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + sizes[i];
  },
  validateHalfWidthAlphaNumeric (str) {
    const reg = new RegExp(/^[a-z0-9|ｧ-ﾝﾞﾟ]+$/i);
    return reg.test(str);
  },
  validateHalfWidthNumberDash (str) {
    const reg = new RegExp(/^[0-9-]+$/i);
    return reg.test(str);
  },
  validateNGWord (value) {
    const regex = /([\u2103|\u2105|\u2109|\u2113|\u2116|\u2121|\u2153|\u2154|\u215b|\u215c|\u215d|\u215e|\u2160|\u2161|\u2162|\u2163|\u2164|\u2165|\u2166|\u2167|\u2168|\u2169|\u216a|\u216b|\u2170|\u2171|\u2172|\u2173|\u2174|\u2175|\u2176|\u2177|\u2178|\u2179|\u2190|\u2191|\u2192|\u2193|\u2194|\u2195|\u2196|\u2197|\u2198|\u2199|\u21a8|\u21b8|\u21b9|\u21d2|\u21d4|\u21e7|\u2200|\u2202|\u2203|\u2206|\u2207|\u2208|\u220b|\u220f|\u2211|\u2212|\u2215|\u2219|\u221a|\u221d|\u221e|\u221f|\u2220|\u2223|\u2225|\u2227|\u2228|\u2229|\u222a|\u222b|\u222c|\u222e|\u2234|\u2235|\u2236|\u2237|\u223c|\u223d|\u2248|\u224c|\u2252|\u2260|\u2261|\u2264|\u2265|\u2266|\u2267|\u226a|\u226b|\u226e|\u226f|\u2282|\u2283|\u2286|\u2287|\u2295|\u2299|\u22a5|\u22bf|\u2310|\u2312|\u2320|\u2321|\u2460|\u2461|\u2462|\u2463|\u2464|\u2465|\u2466|\u2467|\u2468|\u2469|\u246a|\u246b|\u246c|\u246d|\u246e|\u246f|\u2470|\u2471|\u2472|\u2473|\u2474|\u2475|\u2476|\u2477|\u2478|\u2479|\u247a|\u247b|\u247c|\u247d|\u247e|\u247f|\u2480|\u2481|\u2482|\u2483|\u2484|\u2485|\u2486|\u2487|\u2488|\u2489|\u248a|\u248b|\u248c|\u248d|\u248e|\u248f|\u2490|\u2491|\u2492|\u2493|\u2494|\u2495|\u2496|\u2497|\u2498|\u2499|\u249a|\u249b|\u249c|\u249d|\u249e|\u249f|\u24a0|\u24a1|\u24a2|\u24a3|\u24a4|\u24a5|\u24a6|\u24a7|\u24a8|\u24a9|\u24aa|\u24ab|\u24ac|\u24ad|\u24ae|\u24af|\u24b0|\u24b1|\u24b2|\u24b3|\u24b4|\u24b5|\u24d0|\u24d1|\u24d2|\u24d3|\u24d4|\u24d5|\u24d6|\u24d7|\u24d8|\u24d9|\u24da|\u24db|\u24dc|\u24dd|\u24de|\u24df|\u24e0|\u24e1|\u24e2|\u24e3|\u24e4|\u24e5|\u24e6|\u24e7|\u24e8|\u24e9|\u24ea|\u2500|\u2501|\u2502|\u2503|\u2504|\u2505|\u2506|\u2507|\u2508|\u2509|\u250a|\u250b|\u250c|\u250d|\u250e|\u250f|\u2510|\u2511|\u2512|\u2513|\u2514|\u2515|\u2516|\u2517|\u2518|\u2519|\u251a|\u251b|\u251c|\u251d|\u251e|\u251f|\u2520|\u2521|\u2522|\u2523|\u2524|\u2525|\u2526|\u2527|\u2528|\u2529|\u252a|\u252b|\u252c|\u252d|\u252e|\u252f|\u2530|\u2531|\u2532|\u2533|\u2534|\u2535|\u2536|\u2537|\u2538|\u2539|\u253a|\u253b|\u253c|\u253d|\u253e|\u253f|\u2540|\u2541|\u2542|\u2543|\u2544|\u2545|\u2546|\u2547|\u2548|\u2549|\u254a|\u254b|\u2550|\u2551|\u2552|\u2553|\u2554|\u2555|\u2556|\u2557|\u2558|\u2559|\u255a|\u255b|\u255c|\u255d|\u255e|\u255f|\u2560|\u2561|\u2562|\u2563|\u2564|\u2565|\u2566|\u2567|\u2568|\u2569|\u256a|\u256b|\u256c|\u256d|\u256e|\u256f|\u2570|\u2571|\u2572|\u2573|\u2574|\u2580|\u2581|\u2582|\u2583|\u2584|\u2585|\u2586|\u2587|\u2588|\u2589|\u258a|\u258b|\u258c|\u258d|\u258e|\u258f|\u2590|\u2591|\u2592|\u2593|\u2594|\u2595|\u25a0|\u25a1|\u25a3|\u25a4|\u25a5|\u25a6|\u25a7|\u25a8|\u25a9|\u25aa|\u25ab|\u25ac|\u25b2|\u25b3|\u25b6|\u25b7|\u25ba|\u25bc|\u25bd|\u25c0|\u25c1|\u25c4|\u25c6|\u25c7|\u25c8|\u25ca|\u25cb|\u25ce|\u25cf|\u25d0|\u25d1|\u25d8|\u25d9|\u25e2|\u25e3|\u25e4|\u25e5|\u25e6|\u25ef|\u2605|\u2606|\u2609|\u260e|\u260f|\u261c|\u261e|\u263a|\u263b|\u263c|\u2640|\u2642|\u2660|\u2661|\u2663|\u2664|\u2665|\u2666|\u2667|\u2668|\u2669|\u266a|\u266b|\u266c|\u266d|\u266f|\u3280|\u3281|\u3282|\u3283|\u3284|\u3285|\u3286|\u3287|\u3288|\u3289|\u328a|\u328b|\u328c|\u328d|\u328e|\u328f|\u3290|\u3291|\u3292|\u3293|\u3294|\u3295|\u3296|\u3297|\u3298|\u3299|\u329a|\u329b|\u329c|\u329d|\u329e|\u329f|\u32a0|\u32a1|\u32a2|\u32a3|\u32a4|\u32a5|\u32a6|\u32a7|\u32a8|\u32a9|\u32aa|\u32ab|\u32ac|\u32ad|\u32ae|\u32af|\u32b0|\u32c0|\u32c1|\u32c2|\u32c3|\u32c4|\u32c5|\u32c6|\u32c7|\u32c8|\u32c9|\u32ca|\u32cb|\u32d0|\u32d1|\u32d2|\u32d3|\u32d4|\u32d5|\u32d6|\u32d7|\u32d8|\u32d9|\u32da|\u32db|\u32dc|\u32dd|\u32de|\u32df|\u32e0|\u32e1|\u32e2|\u32e3|\u32e4|\u32e5|\u32e6|\u32e7|\u32e8|\u32e9|\u32ea|\u32eb|\u32ec|\u32ed|\u32ee|\u32ef|\u32f0|\u32f1|\u32f2|\u32f3|\u32f4|\u32f5|\u32f6|\u32f7|\u32f8|\u32f9|\u32fa|\u32fb|\u32fc|\u32fd|\u32fe|\u3300|\u3301|\u3302|\u3303|\u3304|\u3305|\u3306|\u3307|\u3308|\u3309|\u330a|\u330b|\u330c|\u330d|\u330e|\u330f|\u3310|\u3311|\u3312|\u3313|\u3314|\u3315|\u3316|\u3317|\u3318|\u3319|\u331a|\u331b|\u331c|\u331d|\u331e|\u331f|\u3320|\u3321|\u3322|\u3323|\u3324|\u3325|\u3326|\u3327|\u3328|\u3329|\u332a|\u332b|\u332c|\u332d|\u332e|\u332f|\u3330|\u3331|\u3332|\u3333|\u3334|\u3335|\u3336|\u3337|\u3338|\u3339|\u333a|\u333b|\u333c|\u333d|\u333e|\u333f|\u3340|\u3341|\u3342|\u3343|\u3344|\u3345|\u3346|\u3347|\u3348|\u3349|\u334a|\u334b|\u334c|\u334d|\u334e|\u334f|\u3350|\u3351|\u3352|\u3353|\u3354|\u3355|\u3356|\u3357|\u3358|\u3359|\u335a|\u335b|\u335c|\u335d|\u335e|\u335f|\u3360|\u3361|\u3362|\u3363|\u3364|\u3365|\u3366|\u3367|\u3368|\u3369|\u336a|\u336b|\u336c|\u336d|\u336e|\u336f|\u3370|\u3371|\u3372|\u3373|\u3374|\u3375|\u3376|\u337b|\u337c|\u337d|\u337e|\u337f|\u3380|\u3381|\u3382|\u3383|\u3384|\u3385|\u3386|\u3387|\u3388|\u3389|\u338a|\u338b|\u338c|\u338d|\u338e|\u338f|\u3390|\u3391|\u3392|\u3393|\u3394|\u3395|\u3396|\u3397|\u3398|\u3399|\u339a|\u339b|\u339c|\u339d|\u339e|\u339f|\u33a0|\u33a1|\u33a2|\u33a3|\u33a4|\u33a5|\u33a6|\u33a7|\u33a8|\u33a9|\u33aa|\u33ab|\u33ac|\u33ad|\u33ae|\u33af|\u33b0|\u33b1|\u33b2|\u33b3|\u33b4|\u33b5|\u33b6|\u33b7|\u33b8|\u33b9|\u33ba|\u33bb|\u33bc|\u33bd|\u33be|\u33bf|\u33c0|\u33c1|\u33c2|\u33c3|\u33c4|\u33c5|\u33c6|\u33c7|\u33c8|\u33c9|\u33ca|\u33cb|\u33cc|\u33cd|\u33ce|\u33cf|\u33d0|\u33d1|\u33d2|\u33d3|\u33d4|\u33d5|\u33d6|\u33d7|\u33d8|\u33d9|\u33da|\u33db|\u33dc|\u33dd|\u33e0|\u33e1|\u33e2|\u33e3|\u33e4|\u33e5|\u33e6|\u33e7|\u33e8|\u33e9|\u33ea|\u33eb|\u33ec|\u33ed|\u33ee|\u33ef|\u33f0|\u33f1|\u33f2|\u33f3|\u33f4|\u33f5|\u33f6|\u33f7|\u33f8|\u33f9|\u33fa|\u33fb|\u33fc|\u33fd|\u33fe|\u3231]|\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]|\ud7c9[\ude00-\udeff]|[\u2600-\u27BF]|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]))/gmi;
    let trimS = value.replace(/\r?\n/g, '');
    while (regex.exec(trimS) !== null) {
      return true
    }
    return false
  },
  exportToCSV (data, fileName = 'dowload.csv', mimeType = 'text/csv;encoding:utf-8') {
    let csvContent = '';
    data.forEach(function (infoArray, index) {
      let dataString = infoArray.join(',');
      csvContent += index < data.length ? dataString + '\n' : dataString;
    });

    /* Convert from UNICODE to ShiftJIS */
    let encoding = mimeType.toLowerCase()
    if (encoding.includes('sjis')) {
      csvContent = this.convertShiftJIS(csvContent)
    }

    let a = document.createElement('a')
    if (navigator.msSaveBlob) {
      // IE10
      navigator.msSaveBlob(new Blob([csvContent], {type: mimeType}), fileName);
    } else if (URL && 'download' in a) {
      a.href = URL.createObjectURL(new Blob([csvContent], {type: mimeType}));
      a.setAttribute('download', fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      location.href = 'data:application/octet-stream,' + encodeURIComponent(csvContent); // only this mime type is supported
    }
  },
  formatMoney (amount, decimalCount = 0, decimal = '.', thousands = ',') {
    decimalCount = isNaN(decimalCount = Math.abs(decimalCount)) ? 0 : decimalCount;
    var negativeSign = amount < 0 ? '-' : '';
    let num = parseInt(amount = Math.abs(Number(amount) || 0)).toString();

    return negativeSign + num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - num).toFixed(decimalCount).slice(2) : '');
  },
  csvToArray (text) {
    let p = '';
    let row = [''];
    let ret = [row]
    let i = 0
    let r = 0
    let s = !0
    let l
    for (l of text) {
      if (l === '"') {
        if (s && l === p) row[i] += l;
        s = !s;
      } else if (l === ',' && s) l = row[++i] = '';
      else if (l === '\n' && s) {
        if (p === '\r') row[i] = row[i].slice(0, -1);
        row = ret[++r] = [l = ''];
        i = 0;
      } else row[i] += l;
      p = l;
    }
    return ret;
  },
  convertShiftJIS (target) {
    const uniArray = encoding.stringToCode(target);
    const sjisArray = encoding.convert(uniArray, 'SJIS', 'UNICODE');
    // const sjisString = Encoding.codeToString(sjisArray);

    return new Uint8Array(sjisArray);
  },
  validatePostalCode (value) {
    const reg = new RegExp(/^([0-9]{3}-[0-9]{4}$)/i);
    return reg.test(value);
  },
  formatPostcode (value) {
    let re = /^([0-9]{1,3})([^0-9]?([0-9]*))?/

    let m = value.match(re)
    if (!m) {
      return value
    }
    if (m[3]) {
      return m[1] + '-' + m[3]
    } else {
      return value
    }
  },
}



// WEBPACK FOOTER //
// ./src/helpers/index.js